export enum Period {
    CurrentQuarter = 'current-quarter',
    CarriedOverPreviousQuarter = 'carried-over-previous-quarter',
    CarriedOverPreviousQuarterOrCurrentQuarter = 'carried-over-previous-quarter-or-current-quarter',
}
